function deNodify(child, mapCursorToNode = false) {
  return (child?.edges || child || []).map((x) =>
    Object.assign(x?.node || x, mapCursorToNode ? { cursor: x?.cursor } : {})
  );
}

module.exports = deNodify;
